import { MantineTheme } from "@mantine/core";


   export const themeProvider = (theme: MantineTheme) => ({
        color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[9],
        '&:hover': {
            backgroundColor: theme.colors.teal[9],
            color: theme.colors.gray[0]
        },
    })